import React from 'react'
import { ReactSVG } from 'react-svg'

import coffee from 'images/svgs/coffee.svg'

const Loader = (color='#3109A3') => (
  <div className="text-center">
    <ReactSVG style={{color: color}} src={coffee}/>
  </div>
)

export default Loader
